<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <div class="banner">
                    <div class="row align-items-center justify-content-center">
                        <img src="assets/dmk.png" alt="MyRoots Logo" class="img-circle elevation-2 forImg1" style="opacity: 1.8;"> 
                        
                        <h5 class="font-weight-bold forImgTxtNew ml-3">Welcome to MyRoots Mentor Registration</h5>
                        <button type="button" class="close font-weight-bold" (click)="close()">
                            &times;
                        </button>
                    </div>
                    </div>
                </div>
                <!-- <div class="banner">
                    <div class="row align-items-center">
                        <div class="col-2 col-md-1 text-left">
                            <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2 forImg1" style="opacity: .8;">
                        </div>
                        <div class="col-10 col-md-11 text-center">
                            <h5 class="font-weight-bold forImgTxtNew">Welcome to MyRoots Mentor Registration</h5>
                        </div>
                    </div>
                </div> -->
                




        <div class="card-danger">


            <div class="card-body p-2">

                <form class="register-form" [formGroup]='createmeetingform' (ngSubmit)="postdata(createmeetingform)"
                    autocomplete="off">
                    <div class="row m-0" >
                        <div class="col-12 d-flex justify-content-center align-items-center flex-column flex-md-row">
                            <label class="form-label resident">Category<a style="color:#ff0000">*</a></label>
                            <div class="form-check resident mx-2">
                                <input class="form-check-input radio-button " type="radio" name="flexRadioDefault"
                                    (click)="handleRadioClick('Normal')" id="flexRadioDefault1" checked>
                                <label class="form-check-label resident" for="flexRadioDefault1" style="margin-left: 10px;">
                                    Resident Indian
                                </label>

                            </div>
                            <div class="form-check resident mx-2">
                                <input class="form-check-input radio-button" type="radio" name="flexRadioDefault"
                                    (click)="handleRadioClick('Available')" id="flexRadioDefault2" >
                                <label class="form-check-label resident" for="flexRadioDefault2" style="margin-left: 10px;">
                                    Non-Resident
                                </label>
                            </div>


                        </div>
                    </div>
                    <div class="form-group row" style="border:1px solid#dfdcdc;background-color:#dfdcdc ; border-radius: 10px;
height:offsetHeight;padding:20px 5px;">
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>First Name<span class="required">*</span></label>
                            <input pInputText type="text" class="form-control" formControlName="first_name"     (input)="onInputName($event)"

                                placeholder="Enter First Name">
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('first_name').touched && createmeetingform.get('first_name').value=='')">
                                Please fill the field</div>
                            <div *ngIf="createmeetingform.get('first_name')?.hasError('pattern') && createmeetingform.get('first_name')?.touched"
                                class="text-danger fs-13 mt-1" style="color:red !important;">
                                Please enter alphabets only.
                            </div>

                        </div>
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label> Last Name<span class="required">*</span></label>
                            <input pInputText type="text" class="form-control" formControlName="last_name"     (input)="onInputName($event)"

                                placeholder="Enter Last Name ">
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('last_name').touched && createmeetingform.get('last_name').value=='')">
                                Please fill the field</div>
                            <div *ngIf="createmeetingform.get('last_name')?.hasError('pattern') && createmeetingform.get('last_name')?.touched"
                                class="text-danger fs-13 mt-1" style="color:red !important;">
                                Please enter alphabets only.
                            </div>
                        </div>
                    <!-- </div>


                    <div class="form-group row"> -->
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Email<span class="required">*</span></label>
                            <input type="email" class="form-control" formControlName="email"
                                placeholder="Enter valid email id to get login credentials "
                                (keyup)="getemail(createmeetingform.get('email').value)" required>
                                <div style="color:red;"
                                *ngIf="createmeetingform.get('email').touched && createmeetingform.get('email').hasError('required')">
                             Please fill the field
                           </div>
                         
                           <!-- Error message for duplicate email -->
                           <div class="invalid-msg"
                                *ngIf="test_email === 'true' && createmeetingform.get('email').value !== '' && createmeetingform.get('email').status === 'VALID'"
                                style="color:red !important;">
                             This email already exists, please enter a new email.
                           </div>
                         
                           <!-- Error message for invalid email pattern -->
                           <div *ngIf="createmeetingform.get('email').hasError('pattern') && createmeetingform.get('email').touched"
                                style="color:red !important;">
                             Please enter a valid email address.
                           </div>
                            
                            
                            
                        </div>
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <!-- <label>WhatsApp Number With Country Code(User ID) <span class="required "> *</span></label> -->
                            <label>{{ whatsappLabel }} <span class="required"> *</span></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <input type="text" class="form-control" formControlName="countryCode" (keypress)="onKeyPressCountryCode($event)" maxlength="4" required  style="width: 80px;" [value]="countryCode">
                                </div>
                                <input type="text" class="form-control" formControlName="number"
                                    placeholder="Enter valid WhatsApp number to get Login credentials"
                                    (keyup)="getphone(createmeetingform.get('number').value)"
                                    (input)="onInputNumber($event)" 
 
                                    (keypress)="onKeyPressNumber($event)" required>
                            </div>
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('number').touched && createmeetingform.get('number').value=='')">
                                Please fill the field</div>
                            <div class="invalid-msg"
                                *ngIf="test_ph=='true' && createmeetingform.get('number').value !='' && createmeetingform.get('number').status=='VALID'"
                                style="color:red !important;">This phone number already exists</div>
                            <div *ngIf="createmeetingform.get('number').hasError('pattern') && createmeetingform.get('number').touched"
                                style="color:red !important;">
                                Please enter a valid WhatsApp number
                            </div>
                        </div>
                        

                    </div>

                    <div class="form-group row" style="border:1px solid #dfdcdc; background-color:#dfdcdc ; border-radius: 10px;
height:offsetHeight;padding:20px 5px;">

                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Academic Details<span class="required ">
                                    *</span></label>
                            <input pInputText type="text" class="form-control" formControlName="education" placeholder="Eg:- B.E., B.Tech., M.Sc., M.Phil., Ph.D.,etc
                                                    " required>
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('education').touched && createmeetingform.get('education').value=='')">
                                Please fill
                                the field</div>
                            <div *ngIf="createmeetingform.get('education')?.hasError('pattern') && createmeetingform.get('education')?.touched"
                                class="text-danger fs-13 mt-1" style="color:red !important;">
                                Numeric values are not allowed.
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Branch/Dept/Subject<span class="required ">
                                    *</span></label>
                            <select class="form-control" formControlName="branch">
                                <option selected>Select Branch</option>
                                <option>Civil</option>
                                <option>Mechanical</option>
                                <option>Computer</option>
                                <option>IT</option>
                                    <option>Maths</option>
                                    <option>Physics</option>
                                    <option>Chemistry</option>
                                    <option>Botany</option>
                                    <option>Zoology</option>
                                    <option>Commerce</option>
                                    <option>Accountancy</option>
                                    <option>Economics</option>
                                    <option>History</option>
                                    <option>Civics</option>
                                    <option>Geography</option>
                                    <option>Aptitude</option>
                                    <option>General knowledge</option>
                                    <option>Electrical and Electronics</option>
                                    <option>Electronics and communication</option>
                                    <option>Others</option>
                            </select>

                            <!-- <input pInputText type="text" class="form-control" formControlName="branch"
                                                    placeholder="Enter Branch" required> -->
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('branch').touched && createmeetingform.get('branch').value=='')">
                                Please fill
                                the field</div>
                        </div>
                    <!-- </div>
                    <div class="form-group row" id="Check1"> -->
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>District<span class="required ">
                                    *</span></label><br>
                            <!-- <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst
                                                    (change)="getChangeToConstituey(mydst.value)
                                                    "> -->
                            <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst>
                                <option value="" selected disabled hidden>Select District</option>

                                <option *ngFor="let option of district_list" (value)="option">
                                    {{option}}</option>
                            </select>
                            <div style="color:red;"
                                *ngIf=" createmeetingform.get('district').touched && createmeetingform.get('district').value==''">
                                Please fill
                                the field</div>
                        </div>
                        <!-- <div class="col-sm-6">
                                                <label>Constituency<span class="required ">
                                                        *</span></label>
                                                <select class="form-control" formControlName="constituency" [(ngModel)]="OBConstituency">
                                                    <option value="" selected disabled>Select constituency</option>
                                                    <option *ngFor="let option of user_constituency" (value)="option">
                                                        {{option}}</option>
                                                </select>
                                                <div style="color:red;"
                                                    *ngIf="createmeetingform.get('constituency').touched && createmeetingform.get('constituency').value==''">
                                                    Please fill
                                                    the field
                                                </div>
                                                </div> -->

                        <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Activity<span class="required ">
                                    *</span></label>
                            <select class="form-control" formControlName="activity" [(ngModel)]="activity">
                                <option selected>Select Activity</option>
                                <option>Mentoring</option>
                                <option>Presenting</option>
                                <option>Speech</option>

                            </select>
                            <div style="color:red;"
                                *ngIf="createmeetingform.get('activity').touched && createmeetingform.get('activity').value==''">
                                Please fill
                                the field
                            </div> 
                        </div>-->
                    <!-- </div>
                    <div class="form-group row"> -->
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Area of Expertise <span class="required ">
                                    *</span></label>
                            <input pInputText type="text" class="form-control" formControlName="area"
                                placeholder="Eg:Botany, Organic Chemistry, Marketing.,etc"
                                (input)="onInputName($event)" 
                                required>
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('area').touched && createmeetingform.get('area').value=='')">
                                Please fill
                                the field</div>
                            <div *ngIf="createmeetingform.get('area')?.hasError('pattern') && createmeetingform.get('area')?.touched"
                                class="text-danger fs-13 mt-1" style="color:red !important;">
                                Please provide valid input.
                            </div>  
                        </div>
                        <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Courses Volunteering
                                <span class="required">
                                    *</span></label>
                               <ng-multiselect-dropdown [placeholder]="'Select Courses'" [settings]="dropdownSettings"
                                [data]="dropdownList" formControlName="courses">
                            </ng-multiselect-dropdown>
                            <div style="color:red;"
                                *ngIf="(createmeetingform.get('courses').touched && createmeetingform.get('courses').value=='')">
                                Please fill
                                the field</div>
                        </div> -->
                    <!-- </div>



                    <div class="form-group row"> -->
                        <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                            <label>Photo <span class="required">*</span></label>
                            <input type="file" formControlName="image" id="file" class="form-control"
                                (change)="selectFiles($event)" />
                            <p style="color:black; margin-bottom: unset;">Note: File size should be 60 kb and format
                                jpeg,jpg,png</p>
                            <div style="color:red;"
                                *ngIf="createmeetingform.get('image').touched && (createmeetingform.get('image').hasError('required') || createmeetingform.get('image').hasError('imageSizeExceeded'))">
                                Please upload valid image
                            </div>

                        </div> -->
                    <!-- </div>
                    <div class="form-group row" *ngIf="this.available"> -->
                        <!-- <div class="col-sm-6">
                            <label class="form-label">Available Days<a style="color:red">*</a></label>
                            <input type="number" placeholder="Enter Available Days" formControlName="available_days"
                                class="form-control" />
                            <div style="color:red;"
                                *ngIf="createmeetingform.get('available_days').touched && createmeetingform.get('available_days').value==''">
                                Please fill
                                the field</div>
                        </div> -->

                        <div class="col-sm-6" *ngIf="this.available">
                            <label class="form-label">Country<a style="color:red">*</a></label>
                            <select formControlName="country" class="form-control">
                                <option value="" disabled selected>Select your country</option>
                                <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
                            </select>
                            <div style="color:red;" *ngIf="createmeetingform.get('country').touched && createmeetingform.get('country').value==''">
                                Please select a country
                            </div>
                        </div>
                        
                    </div>
                    <!-- <div class="form-group row" *ngIf="available">
                        <div class="col-sm-6">
                            <label class="form-label">Available From Date<a style="color:red">*</a></label>
                            <input type="date" placeholder="Enter Available From Date"
                                formControlName="available_from_date" class="form-control" [min]="getCurrentDate()"
                                >
                            <div style="color:red;"
                                *ngIf="createmeetingform.get('available_from_date').touched && createmeetingform.get('available_from_date').value == ''">
                                Please fill the field
                            </div>
                            <div style="color:red;" *ngIf="createmeetingform.get('available_from_date').touched && createmeetingform.get('available_from_date').hasError('invalidDate')">
                                Please select a valid date
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <label class="form-label">Available To Date<a style="color:red">*</a></label>
                            <input placeholder="Enter Available To Date" type="date" formControlName="available_to_date"
                                class="form-control" [min]="getFutureDate()">
                            <div style="color:red;"
                                *ngIf="createmeetingform.get('available_to_date').touched && createmeetingform.get('available_to_date').value == ''">
                                Please fill the field
                            </div>
                            <div style="color:red;" *ngIf="createmeetingform.get('available_to_date').touched && createmeetingform.get('available_to_date').hasError('invalidToDate')">
                                Please select a valid date
                            </div>
                        </div>
                    </div> -->

                    <div class="form-group row" style="border:1px solid #dfdcdc;background-color:#dfdcdc ; border-radius: 10px;
height:offsetHeight;padding:20px 5px;">
                        <div class="col-sm-6">
                            <label class="form-label">Password<a style="color:red">*</a></label>
                            <!-- <div class="input-group">
                              <input #passwordInput type="{{ hidePassword ? 'password' : 'text' }}"
                                     placeholder="Enter Password" formControlName="password" class="form-control" />
                              <div class="input-group-append" style=" border: 1px solid gray">
                                <div class="btn"  (click)="togglePasswordVisibility()">
                                        <img src="assets/eye.jpg" alt="Example Image" style="height:9px">
                                      
                                    </div>
                              </div>
                            </div> -->
                            <div class="input-group">
                                <input type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" formControlName="password"
                                    id="password" placeholder="Enter Password"  />
                                    <div class="input-group-append" style="background-color: white;  border-radius: 5px;">
                                        <div class="input-group-text" (click)="togglePasswordVisibility()">
                                            <img src="assets/eye.png" alt="Eye Icon" style="height:9px;mix-blend-mode: multiply;">
                                        </div></div>
                                       
                                    </div>
                                    <div *ngIf="createmeetingform.get('password').touched">
                                        <div *ngIf="createmeetingform.get('password').hasError('required')" style="color: red;">
                                            Please fill the field
                                        </div>
                                        <div *ngIf="createmeetingform.get('password').hasError('passwordStrength')" style="color: red;">
                                          Password must be at least 8 characters long, with at least 1 uppercase letter, 1 lowercase letter, and 1 special character.
                                        </div>
                                      </div>
                          </div>
                          <div class="col-sm-6 mb-3 mb-sm-0">
                            <label class="form-label">Confirm Password<span style="color: red">*</span></label>
                            <!-- <div class="input-group">
                                <input id="confirm_password" formControlName="confirm_password" type="{{ hidepassword ? 'password' : 'text' }}" placeholder="Enter Confirm Password" class="form-control" (blur)="handleBlurChange()" />
                                <div class="input-group-append" style="border: 1px solid gray">
                                    <div class="btn" (click)="togglePassword()">
                                        <img src="assets/eye.jpg" alt="Eye Icon" style="height:9px">
                                    </div>
                                </div>
                            </div> -->
                            <div class="input-group">
                                <input type="{{ hidepassword ? 'password' : 'text' }}" class="form-control" formControlName="confirm_password"
                                    id="confirm_password" placeholder="Enter Confirm Password" (blur)="handleBlurChange()" />
                                    <div class="input-group-append" style="background-color: white; border-radius: 5px;">
                                        <div class="input-group-text" (click)="togglePassword()">
                                            <img src="assets/eye.png" alt="Eye Icon" style="height:9px;mix-blend-mode: multiply;">
                                        </div></div>
                                       
                                    </div>
                            <span *ngIf="createmeetingform.hasError('passwordMismatch') && (createmeetingform.dirty || createmeetingform.touched)" style="color: red">Password Mismatch</span>
                        </div>
                        
                    </div>
                    <br />
                    <div class="form-group row" style="border:none ; border-radius: 10px;height:offsetHeight;padding:10px 5px;">
                        <div class="col-sm-12">
                          <label>CAPTCHA<span class="required"> *</span></label>
                          <re-captcha class="g-recaptcha"
                          siteKey="6LfgWy4qAAAAAFA_fFnEtWlW0TnhfH0p73y86j_5"
                            (resolved)="onCaptchaResolved($event)" 
                            style="transform:scale(0.77);-webkit-transform:scale(0.77);transform-origin:0 0;-webkit-transform-origin:0 0;">
                          </re-captcha>
                          <div style="color:red;" *ngIf="captchaError">Please complete the CAPTCHA</div>
                        </div>
                      </div>
                    <div class="d-flex justify-content-center">
                        <div >
                            <button class="btn btn-primary  btn-block"
                            [disabled]="isFormDisabled()" >Submit</button>
                        </div>
                    </div>




                </form>
            </div>
        </div>




        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>First Name </label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_name"
                                            formControlName="first_name" placeholder="Enter First Name / முதல் பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Last Name</label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_last_name" formControlName="last_name"
                                            placeholder="Enter  Last Name /கடைசி பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email <span class="required "> *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="CM_email"
                                            formControlName="email" placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>WhatsApp Number<span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="number"
                                            [value]="CM_number" placeholder="Enter WhatsApp Number/வாட்ஸ்அப் எண்"
                                            required readonly="readonly" />

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Academic Details<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_education" formControlName="education"
                                            placeholder="Enter Academic Details/கல்வித் தகுதி">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Branch<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="CM_branch"
                                            formControlName="branch" placeholder="Enter Branch/கிளை">

                                    </div>
                                </div>


                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District<span class="required ">
                                                *</span></label><br>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_district" formControlName="district"
                                            placeholder="Enter District / மாவட்டம்" required>

                                    </div>
                                    <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Constituency<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_constituency" formControlName="constituency"
                                            placeholder="Enter Constituency / தொகுதி">
                                    </div> -->
                                    <div class="col-sm-6">
                                        <label>Activity<span class="required ">
                                                *</span></label>
                                        <select class="form-control" formControlName="activity" [value]="CM_activity">
                                            <option>Mentoring</option>
                                            <option>Presenting</option>
                                            <option>Speech</option>

                                        </select>

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Area of Expertise<span class="required ">
                                                *</span></label>
                                        <input readonly [value]="CM_area" pInputText type="text" class="form-control"
                                            formControlName="area"
                                            placeholder="Enter Area of Expertise/நிபுணத்துவப் பகுதி" required>
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Courses Volunteering<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_courses"
                                            formControlName="courses"
                                            placeholder="Enter Courses Volunteering/படிப்புகள் தன்னார்வத் தொண்டு ">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status<span class="required "> *</span></label>
                                        <input readonly [value]="CM_status" pInputText type="text" class="form-control"
                                            formControlName="status" placeholder="Enter Status" required>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image !=='' && !editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://myroots.redmindtechnologies.com/api/{{CM_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>First Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="CM_name"
                                            formControlName="first_name" placeholder="Enter First Name / முதல் பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Last Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="CM_last_name"
                                            formControlName="last_name" placeholder="Enter  Last Name /கடைசி பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email <span class="required "> *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="CM_email"
                                            formControlName="email" placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>WhatsApp Number<span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="number"
                                            [value]="CM_number" placeholder="Enter WhatsApp Number/வாட்ஸ்அப் எண்"
                                            required />

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Academic Details<span class="required ">
                                                *</span></label>
                                        <input pInputText type="text" class="form-control" [value]="CM_education"
                                            formControlName="education"
                                            placeholder="Enter Academic Details/கல்வித் தகுதி">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Branch<span class="required ">
                                                *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="CM_branch"
                                            formControlName="branch" placeholder="Enter Branch/கிளை">

                                    </div>
                                </div>


                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District <span class="required ">
                                                *</span></label><br>
                                        <!-- <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst
                                                (change)="getChangeToConstituey(mydst.value)"> -->
                                        <select class="form-control" formControlName="district" [(ngModel)]="district"
                                            #mydst>
                                            <option value="" selected disabled hidden>Select District</option>
                                            <option *ngFor="let option of district_list" [ngValue]="option">
                                                {{option}}</option>
                                        </select>

                                    </div>
                                    <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Constituency<span class="required ">
                                                    *</span></label>
                                                <select class="form-control" formControlName="constituency" [(ngModel)]="CM_constituency">
                                                <option value="" selected disabled>Select constituency</option>
                                                <option *ngFor="let option of user_constituency" [ngValue]="option">
                                                    {{option}}</option>
                                                </select>
                                        </div> -->
                                    <div class="col-sm-6">
                                        <label>Activity<span class="required ">
                                                *</span></label>
                                        <select class="form-control" formControlName="activity"
                                            [(ngModel)]="CM_activity">
                                            <option>Mentoring</option>
                                            <option>Presenting</option>
                                            <option>Speech</option>

                                        </select>

                                    </div>

                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Area of Expertise<span class="required ">
                                                *</span></label>
                                        <input [value]="CM_area" pInputText type="text" class="form-control"
                                            formControlName="area"
                                            placeholder="Enter Area of Expertise/நிபுணத்துவப் பகுதி" required>
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Courses Volunteering<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_courses"
                                            formControlName="courses"
                                            placeholder="Enter Courses Volunteering/படிப்புகள் தன்னார்வத் தொண்டு ">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status<span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required
                                            [(ngModel)]="CM_status">
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>


                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image !==''&& editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://myroots.redmindtechnologies.com/api/{{CM_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                    <div class="col-md-6" *ngIf="editfield">
                                        <label>Photo<span class="required">*</span></label>
                                        <input type="file" class="form-control" formControlName="image"
                                            (change)="selectFiles($event)" />
                                    </div>
                                </div>



                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block">Update </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <!-- <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
                <div class="col-md-4 d-flex align-items-center">
                    <a href="/" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                        <svg class="bi" width="30" height="24">
                            <use xlink:href="#bootstrap" />
                        </svg>
                    </a>
                    <span class="mb-3 mb-md-0 text-muted">&copy; {{footerdate}} MyRoots </span>
                </div> -->

                <!-- <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
                    <li class="ms-3"><a class="text-muted" href="#"><svg class="bi" width="24" height="24">
                                <use xlink:href="#twitter" />
                            </svg></a></li>
                    <li class="ms-3"><a class="text-muted" href="#" ><svg xmlns="http://www.w3.org/2000/svg" style="margin-top:3px;" width="25" height="25" viewBox="0 0 256 256">
                        <g fill="none">
                            <rect width="256" height="256" fill="url(#skillIconsInstagram0)" rx="60" />
                            <rect width="256" height="256" fill="url(#skillIconsInstagram1)" rx="60" />
                            <path fill="#fff"
                                d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604h.031Zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563v.025Zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12v.004Zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355h.002Zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334Z" />
                            <defs>
                                <radialGradient id="skillIconsInstagram0" cx="0" cy="0" r="1"
                                    gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#FD5" />
                                    <stop offset=".1" stop-color="#FD5" />
                                    <stop offset=".5" stop-color="#FF543E" />
                                    <stop offset="1" stop-color="#C837AB" />
                                </radialGradient>
                                <radialGradient id="skillIconsInstagram1" cx="0" cy="0" r="1"
                                    gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                                    gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#3771C8" />
                                    <stop offset=".128" stop-color="#3771C8" />
                                    <stop offset="1" stop-color="#60F" stop-opacity="0" />
                                </radialGradient>
                            </defs>
                        </g>
                    </svg>

                        </a></li>
                    <li class="ms-3"><a class="text-muted" href="#"><svg  xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 72 72">
                        <path fill="#61b2e4" d="M57 12H15a4 4 0 0 0-4 4v42a4 4 0 0 0 4 4h42a4 4 0 0 0 4-4V16a4 4 0 0 0-4-4Z" />
                        <path fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2" d="M36.935 62.009h9.5" />
                        <path fill="#fff"
                            d="M48.5 26.844h4.688v-7.031c-3.126 0-15.626-3.125-15.626 10.156v4.687h-6.25v7.813h6.25v18.564l7.813-.014V42.47h7.031l.781-7.813h-7.812V29.97c0-3.125 2.344-3.125 3.125-3.125Z" />
                        <g fill="none" stroke="#000" stroke-width="2">
                            <path stroke-miterlimit="10"
                                d="M45.619 62h12.155A3.226 3.226 0 0 0 61 58.774V15.226A3.226 3.226 0 0 0 57.774 12H14.226A3.226 3.226 0 0 0 11 15.226v43.548A3.226 3.226 0 0 0 14.226 62h23.476" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M45.618 62V42.208h7.125l.792-7.917h-7.917v-4.75c0-3.167 2.375-3.167 3.167-3.167h4.75V19.25c-3.2-.324-15.834-3.166-15.834 10.292v4.75h-6.333v7.917h6.333V62" />
                        </g>
                    </svg></a></li>
                </ul> -->
            <!-- </footer> -->
            <div class="footer">
                <div class="text-center p-3">
                  <p>Copyright © MyRoots. Developed by <a href="https://redmindtechnologies.com/" target="_blank">RedMind Technologies</a> {{footerdate}}</p>
                </div>
        </div>